<form class="composer-form" ngNoForm (submit)="$event.preventDefault()">
  <div class="composer">
    <div class="search-with-scan">
      <input #searchInput type="text" class="product-search-input" data-testid="need-composer-input" [ngModel]="newNeedText"
        [ngModelOptions]="{ standalone: true }" (ngModelChange)="onProductSearchInput($event)"
        (keydown.enter)="$event.preventDefault()" placeholder="חיפוש מוצר" aria-label="חיפוש מוצר"
        autocomplete="off" inputmode="search" dir="rtl" [disabled]="!selectedBranchId" />
      @if (showScanButton) {
      <button type="button" class="scan-button" data-testid="barcode-scan-button" (click)="startBarcodeScan()"
        aria-label="סריקת ברקוד" title="סריקת ברקוד">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
          <path d="M3 7V5a2 2 0 0 1 2-2h2" />
          <path d="M17 3h2a2 2 0 0 1 2 2v2" />
          <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
          <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
          <line x1="8" y1="7" x2="8" y2="17" />
          <line x1="12" y1="7" x2="12" y2="17" />
          <line x1="16" y1="7" x2="16" y2="17" />
        </svg>
      </button>
      }
    </div>
    @if (!selectedBranchId) {
    <div class="composer-no-branch-hint" data-testid="no-branch-hint">
      <span>יש לבחור עיר וסניף להשוואה כדי לחפש ולהוסיף מוצרים.</span>
      <button type="button" class="inline-open-settings-btn" (click)="openLocationSettings.emit()">
        בחירת עיר וסניף
      </button>
    </div>
    }
  </div>

  <app-barcode-scanner-modal
    [isOpen]="scanOpen"
    [savePackagePhoto]="auth.isLoggedIn"
    (close)="stopBarcodeScan()"
    (scanCode)="onBarcodeScanned($event)"
    (scanErrorEvent)="onBarcodeScanError($event)"
  />

  @if (!selectedCity) {
  <p class="search-hint">בחרו עיר כדי לטעון את הסניפים הזמינים.</p>
  } @else if (!selectedBranchId) {
  <p class="search-hint">בחרו סניף פיזי כדי להתחיל לחפש מוצרים.</p>
  } @else if (newNeedText.trim().length < 2) { } @else if (searchLoading && searchResults.length === 0) {
  <p class="search-hint" role="status">מחפש התאמות בסניף…</p>
  } @else if (searchResults.length === 0) {
  <p class="search-hint">לא נמצאו מוצרים מתאימים בסניף שנבחר.</p>
  } @else {
  <ng-template #productCard let-product>
    <li class="product-result-card"
      [class.product-result-card--active-popover]="activeCheaperPopupProductId === product.id">
      <div class="product-result-media">
        @if (hasProductPhoto(product.id)) {
        <button type="button" class="product-photo-wrap" data-testid="product-result-photo-wrap"
          aria-label="הגדלת תמונת המוצר" (click)="openImagePopup(product.id)">
          <img class="product-result-photo" data-testid="product-result-photo"
            [src]="productImageUrl(product.id)" alt="" (error)="markImageBroken(product.id)" />
        </button>
        } @else {
        <span aria-hidden="true">{{ productInitial(product) }}</span>
        }
      </div>
      <div class="product-result-body">
        <h3 dir="auto">{{ product.displayName }}</h3>
        @if (productMeta(product); as meta) {
        <p class="product-result-meta">{{ meta }}</p>
        }
        <div class="product-result-price">
          <strong [class.is-promo]="hasPromoMath(product)">
            {{ formatMoney(cardPayPrice(product), product.prices[0].currency) }}
            @if (product.soldByWeight) {
            <span class="price-per">לק״ג</span>
            }
          </strong>
          @if (hasPromoMath(product)) {
          <span class="shelf-struck">
            {{ formatMoney(product.prices[0].price, product.prices[0].currency) }}
          </span>
          }
          @if (hasPromoBadge(product)) {
          <p class="card-promo" data-testid="card-promo">
            <span class="promo-flag">מבצע</span>
            @if (product.prices[0].promoLabel) {
            <span class="promo-text">{{ product.prices[0].promoLabel }}</span>
            }
          </p>
          }
          @if (unitPriceLabel(product); as unitLabel) {
          <span>{{ unitLabel }}</span>
          }
        </div>
        @if (lowestCheaperBranch(product); as cheaper) {
        <div class="cheaper-branch-callout" data-testid="cheaper-branch-callout">
          <div class="cheaper-branch-main">
            <span class="cheaper-badge-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
                <polyline points="17 18 23 18 23 12"></polyline>
              </svg>
            </span>
            <div class="cheaper-badge-content">
              <span class="cheaper-badge-text">
                זול יותר: <strong>{{ formatMoney(cheaper.payPrice, product.prices[0].currency) }}</strong>
                ב{{ cheaper.chainName }} · {{ formatBranchName(cheaper.branchName) }}
              </span>
              <span class="cheaper-savings-tag">
                חיסכון של {{ formatMoney(cheaper.difference, product.prices[0].currency) }}
              </span>
            </div>
          </div>
          @if (additionalCheaperBranches(product).length > 0) {
          <div class="cheaper-more-wrap">
            <button type="button" class="cheaper-more-button" data-testid="cheaper-more-button"
              (click)="toggleCheaperPopup(product.id, $event)"
              [attr.aria-expanded]="activeCheaperPopupProductId === product.id">
              +{{ additionalCheaperBranches(product).length }} סניפים נוספים בעיר
            </button>
            @if (activeCheaperPopupProductId === product.id) {
            <div class="cheaper-popover" role="dialog" aria-label="סניפים נוספים במחיר זול יותר"
              data-testid="cheaper-popover" (click)="$event.stopPropagation()">
              <div class="cheaper-popover-header">
                <h4>סניפים נוספים במחיר זול יותר</h4>
                <button type="button" class="cheaper-popover-close" aria-label="סגור"
                  (click)="closeCheaperPopup($event)">
                  ×
                </button>
              </div>
              <ul class="cheaper-branch-list">
                @for (other of additionalCheaperBranches(product); track other.branchId) {
                <li class="cheaper-branch-row">
                  <div class="cheaper-branch-row-name">
                    <span class="cheaper-row-store">{{ other.chainName }} · {{ formatBranchName(other.branchName) }}</span>
                    @if (other.promoLabel) {
                    <span class="cheaper-row-promo">{{ other.promoLabel }}</span>
                    }
                  </div>
                  <div class="cheaper-branch-row-price">
                    <strong>{{ formatMoney(other.payPrice, product.prices[0].currency) }}</strong>
                    <span class="cheaper-row-diff">חיסכון: {{ formatMoney(other.difference, product.prices[0].currency) }}</span>
                  </div>
                </li>
                }
              </ul>
            </div>
            }
          </div>
          }
        </div>
        }
        @if (product.barcode) {
        <p class="product-result-barcode" data-testid="card-barcode">
          ברקוד <span dir="ltr">{{ product.barcode }}</span>
        </p>
        }
        <dl class="product-match-debug" data-testid="product-match-debug" dir="ltr">
          <div>
            <dt>tier</dt>
            <dd>{{ matchTierLabel(product) }}</dd>
          </div>
          <div>
            <dt>taxonomy</dt>
            <dd>{{ classificationLabel(product) }}</dd>
          </div>
          <div>
            <dt>text</dt>
            <dd>{{ formatScore(product.textScore) }}</dd>
          </div>
          <div>
            <dt>semantic</dt>
            <dd>{{ formatScore(product.semanticScore) }}</dd>
          </div>
          <div>
            <dt>combined</dt>
            <dd>{{ formatScore(product.score) }}</dd>
          </div>
        </dl>
      </div>
      <div class="product-result-footer">
        <app-kg-quantity
          [quantity]="productQuantity(product)"
          [soldByWeight]="!!product.soldByWeight"
          [disabled]="quantityBusy(product)"
          [estimating]="estimatingProductIds.has(product.id)"
          [label]="product.displayName"
          testId="card-quantity"
          (quantityChange)="onCardQuantity(product, $event)"
          (photo)="onBagPhoto(product, $event)"
        />
        @if (basketLine(product)) {
        <span class="in-basket-status" data-testid="in-basket-status">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          בסל
        </span>
        } @else {
        <button type="button" class="primary add-product-button" data-testid="add-search-product"
          (click)="$event.preventDefault(); onAddProductClick(product)"
          [disabled]="addingProductIds.has(product.id) || productQuantity(product) <= 0 || isBasketClosed">
          {{ addingProductIds.has(product.id) ? 'מוסיף…' : 'הוספה לסל' }}
        </button>
        }
      </div>
    </li>
  </ng-template>
  <ul class="product-results" data-testid="smart-product-results">
    @for (product of searchResults; track product.id) {
    <ng-container *ngTemplateOutlet="productCard; context: { $implicit: product }" />
    }
  </ul>
  @if (searchFilling) {
  <p class="search-hint" role="status">ממשיך לחפש התאמות נוספות…</p>
  }
  @if (showBarcodeAlternatives && alternativesLoading) {
  <p class="search-hint" role="status">מחפש חלופות בסניף…</p>
  }
  @if (alternativeResults.length > 0) {
  <h2 class="search-alternatives-heading" data-testid="barcode-alternatives-heading">חלופות מומלצות בסניף זה</h2>
  <ul class="product-results" data-testid="barcode-alternatives">
    @for (product of alternativeResults; track product.id) {
    <ng-container *ngTemplateOutlet="productCard; context: { $implicit: product }" />
    }
  </ul>
  }
  }

  @if (imagePopupProductId; as photoId) {
  <div class="product-photo-popup" appBodyPortal data-testid="product-result-photo-popup" role="dialog"
    aria-modal="true" aria-label="תמונת מוצר מוגדלת" (click)="closeImagePopup($event)">
    <button type="button" class="product-photo-close" aria-label="סגור תמונה"
      (click)="closeImagePopup($event)">
      ×
    </button>
    <img class="product-photo-popup-img" [src]="productImageUrl(photoId)" alt="" />
  </div>
  }
</form>
